// extracted by mini-css-extract-plugin
export default {"flexed_voices_container":"asianVoices_flexed_voices_container__fguhb"};